'use strict';

var plugins = require('../plugins/qunar/');

plugins.forEach(function (plugin) {
    global.hysdk.plugin(plugin);
});


//////////////////
// WEBPACK FOOTER
// ./hysdk.qunar.js
// module id = 59
// module chunks = 3